// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"e46dc022","190":"8cf91961","356":"44ba8861","453":"4a4c5925","745":"8659cfeb"}[chunkId] + ".chunk.js";
};